<div class="highchart-container">
    <div class="highchart"></div>
</div>
